import React from "react";

function Privacy() {
  return (
    <div className="legal-page">
      <h1>Privacy Policy</h1>

      <p>
        NovaPeptide Labs values your privacy and is committed to protecting
        your personal information.
      </p>

      <h2>Information We Collect</h2>
      <p>
        We collect personal information including name, email address,
        shipping address, and payment details solely for order processing
        and business operations.
      </p>

      <h2>Use of Information</h2>
      <p>
        Your information is used to process transactions, provide customer
        support, improve our services, and comply with legal obligations.
      </p>

      <h2>Data Protection</h2>
      <p>
        We implement industry-standard security measures to protect your
        data from unauthorized access, alteration, or disclosure.
      </p>

      <h2>Third-Party Services</h2>
      <p>
        We use secure third-party payment processing for payment processing.
      </p>

      <h2>Contact</h2>
      <p>
        For privacy concerns, contact us at support@novapeptidelabs.org
      </p>
    </div>
  );
}

export default Privacy;
